import http from './request'
import { isLogin } from '@/utils/index'

export const login = (data) => {
  return http({
    url: '/user/user/login',
    method: 'POST',
    data
  })
}

// 获取pwa全局配置参数
export const getPwaConfig = (data) => {
  return http({
    url: '/user/WebUser/getPwaConfig',
    method: 'POST',
    data
  })
}

// 获取pwa用户信息接口
export const getPwaUserList = (data) => {
  return http({
    url: '/user/WebUser/getPwaUserList',
    method: 'POST',
    data
  })
}

// FCM Token上传(new gp)
export const firebaseTokenSave = (data) => {
  return http({
    url: '/user/firebaseToken/save',
    method: 'POST',
    data
  })
}

// 下发FCM消息
export const sendFcm = (data) => {
  return http({
    url: '/user/firebaseToken/sendFcm',
    method: 'POST',
    data
  })
}

// 记录pwa 用户行为
export const recordPwaUserStatus = (data) => {
  return http({
    url: '/user/UserBehaviorRecord/recordPwaUserStatus',
    method: 'POST',
    data
  })
}

// 获取用户行为状态
export const getUserBehavior = (data) => {
  return http({
    url: '/user/UserBehaviorRecord/getList',
    method: 'POST',
    data
  })
}

// 获取用户离线收入
export const getOfflineAssets = (data) => {
  return http({
    url: '/user/user/getOfflineAssets',
    method: 'POST',
    data
  })
}

// pwa广告位列表
export const getADList = (data) => {
  return http({
    url: '/bizBase/Banner/getList',
    method: 'POST',
    data
  })
}

// 订单任务查询
export const getTaskList = (data) => {
  return http({
    url: '/user/ad/getTaskList',
    method: 'POST',
    data
  })
}

// 领取奖励
export const receiveRewardHome = (data) => {
  return http({
    url: '/user/advert/task/review',
    method: 'POST',
    data
  })
}

// 获取游客用户信息
export const getGuestUserInfo = (data) => {
  return http({
    url: '/user/user/getGuestUserInfo',
    method: 'post',
    data
  })
}

// 获取用户信息
export const getUserInfo = (data) => {
  return http({
    url: isLogin() ? 'user/user/getUserInfo' : '/user/user/getGuestUserInfo',
    method: 'post',
    data
  })
}

// 获取用户信息，用于判断用户是否手机号登录
export const getLoginUserInfo = (data) => {
  return http({
    url: 'user/user/getUserInfo',
    method: 'post',
    data
  })
}

// 获取其他用户信息
export const getBasicUserInfo = (data) => {
  return http({
    url: '/user/user/getBasicUserInfo',
    method: 'post',
    data
  })
}

// 获取用户裂变&返利信息（KOL）
export const getInviteSubRebateInfo = (data) => {
  return http({
    url: '/user/user/getInviteSubRebateInfo',
    method: 'post',
    data
  })
}
// 获取用户提现门槛
export const getLevelLimitAmount = (data) => {
  return http({
    url: '/user/Pwa/getLevelLimitAmount',
    method: 'post',
    data
  })
}

// 完成video任务
export const advertCompleteTask = (data) => {
  return http({
    url: '/user/advert/completeTask',
    method: 'post',
    data
  })
}

/**
 * 获取任务详情
 */
export const queryTaskDetail = (params) => {
  return http({
    url: '/user/ad/queryTask',
    method: 'get',
    params
  })
}

/**
 * 获取任务详情
 */
export const socialMediaShareGetInfo = (data) => {
  return http({
    url: '/promotion/SocialMediaShare/getInfo',
    method: 'post',
    data
  })
}

/**
 * 完成视频验证码任务
 */
export const checkPasscode = (data) => {
  return http({
    url: '/advert/checkPasscode',
    method: 'post',
    data
  })
}

/**
 * 获取新手任务列表（new GP）
 */
export const getNewHandTask = (data) => {
  return http({
    url: '/user/advert/task/guide',
    method: 'post',
    data
  })
}

/**
 * 检查是不是老用户
 */
export const checkLogin = (data) => {
  return http({
    url: 'user/checkLogin',
    method: 'post',
    data
  })
}
